import React, {FC} from 'react';
import messages from '../messages';
import {InvoiceFilters} from './types';
import AsyncItemPicker from 'components/async-item-picker';
import DateRangeInput from 'components/date-range-input';
import {FilterMap} from 'features/table/slice/types';
import {useTranslation} from 'react-i18next';
import {Col, Collapse, FormGroup, Row} from 'reactstrap';
import {Option} from 'types/option';
import SearchSection from 'features/table/compenents/search-section';

interface FilterProps {
  filters: FilterMap<InvoiceFilters>;
  onChangeFilters: (key: InvoiceFilters, value: any) => void;
  onClearFilters?: () => void;
}

const Filters: FC<FilterProps> = props => {
  const {t} = useTranslation();
  const {filters, onChangeFilters, onClearFilters} = props;

  return (
    <SearchSection
      onChangeFilters={onChangeFilters}
      onClearFilters={onClearFilters}
      filters={filters}
    >
      <Row className="mb-4">
        <Col lg="4" md="4">
          <FormGroup>
            <AsyncItemPicker
              endPoint="data/payment-types"
              className="mb-1"
              getOptionLabel={(v: Option) => v.label}
              label={t(...messages.paymentType())}
              value={filters['filter[type]']}
              onChange={o => onChangeFilters('filter[type]', o)}
            />
          </FormGroup>
        </Col>

        <Col lg="4" md="4">
          <FormGroup>
            <AsyncItemPicker
              endPoint="data/payment-methods"
              className="mb-1"
              getOptionLabel={(v: Option) => v.label}
              label={t(...messages.paymentMethod())}
              value={filters['filter[payment_method]']}
              onChange={o => onChangeFilters('filter[payment_method]', o)}
            />
          </FormGroup>
        </Col>
        <Col lg="4" md="4">
          <FormGroup>
            <DateRangeInput
              label={t('invoicesPage.payementDate')}
              value={filters['filter[payment_date]'] as string}
              onChange={newDate => {
                onChangeFilters('filter[payment_date]', newDate);
              }}
            />
          </FormGroup>
        </Col>
      </Row>
    </SearchSection>
  );
};

export default Filters;
